import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: 'primary' | 'secondary' | 'white';
}

/**
 * Composant Spinner pour indiquer le chargement
 */
const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className = '',
  color = 'primary'
}) => {
  // Déterminer les classes de taille
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  }[size];
  
  // Déterminer les classes de couleur
  const colorClasses = {
    primary: 'border-primary',
    secondary: 'border-secondary',
    white: 'border-white'
  }[color];
  
  return (
    <div 
      className={`animate-spin rounded-full border-2 border-t-transparent ${sizeClasses} ${colorClasses} ${className}`}
      aria-label="Chargement en cours"
    />
  );
};

export default Spinner;
